module.exports = __webpack_public_path__ + "img/225.f53cd07d.png";